import FacebookIcon from '@/assets/img/logo/facebook.jpg';
import LineIcon from '@/assets/img/logo/line.jpg';
import NaverIcon from '@/assets/img/logo/naver.jpg';
import TwitterIcon from '@/assets/img/logo/twitter.jpg';
import CloseIcon from '@/components/Icon/CloseIcon';
import { useModalStore } from '@/store/modalStore';

import * as S from './style';

interface ModalShareProps {
	onClick: (bool: boolean) => void;
}

const ModalShare = ({ onClick }: ModalShareProps) => {
	const { showModal } = useModalStore();
	const location = window.location.href;
	const url = encodeURIComponent(location);
	const handleCopyClipBoard = async (text: string) => {
		try {
			await navigator.clipboard.writeText(text);
			showModal('주소가 복사되었습니다.\n원하는 곳에 붙여넣기 해 주세요.', 'confirm');
		} catch (error) {
			console.error('복사 실패', error);
		}
	};

	return (
		<S.ModalShareContainer>
			<S.ModalShareBox>
				<S.ModalShareHeader>
					<h4 className="title">공유하기</h4>
					<S.CloseButton type="button" onClick={() => onClick(false)}>
						<CloseIcon />
					</S.CloseButton>
				</S.ModalShareHeader>
				<S.ModalShareContent>
					<S.LogoBox onClick={() => window.open(`https://share.naver.com/web/shareView?url=${url}&title=네이버 공유하기`)}>
						<img src={NaverIcon} alt="facebook" />
					</S.LogoBox>
					<S.LogoBox onClick={() => window.open(`https://band.us/plugin/share?url=${url}`)}>
						<img src={LineIcon} alt="facebook" />
					</S.LogoBox>
					<S.LogoBox onClick={() => window.open(`https://twitter.com/intent/tweet?url=${url}`)}>
						<img src={TwitterIcon} alt="facebook" />
					</S.LogoBox>
					<S.LogoBox onClick={() => window.open(`https://www.facebook.com/sharer/sharer.php?u=${url}`)}>
						<img src={FacebookIcon} alt="facebook" />
					</S.LogoBox>
				</S.ModalShareContent>
				<S.ModalShareUrlWrapper>
					<S.UrlBox readOnly value={location} />
					<S.UrlButton onClick={() => handleCopyClipBoard(location)}>URL복사</S.UrlButton>
				</S.ModalShareUrlWrapper>
			</S.ModalShareBox>
		</S.ModalShareContainer>
	);
};
export default ModalShare;
